import { render, staticRenderFns } from "./AppointmentItem.vue?vue&type=template&id=585fb0ad&scoped=true"
import script from "./AppointmentItem.vue?vue&type=script&lang=js"
export * from "./AppointmentItem.vue?vue&type=script&lang=js"
import style0 from "./AppointmentItem.vue?vue&type=style&index=0&id=585fb0ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585fb0ad",
  null
  
)

export default component.exports